var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "grid-container statistics-header" },
      _vm._l(_vm.titles, function(title, i) {
        return _c("statistics-header", {
          key: title + "-" + i,
          attrs: { title: title }
        })
      }),
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "statistics-divider" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "grid-container statistics-columns" },
      _vm._l(_vm.row, function(column, index) {
        return _c("statistics-column", {
          key: column.name + "-" + index,
          attrs: { items: column.items }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }